import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Cart } from '../../interface/checkoutInterface';
import { IProductModalProps } from '../../components/predefinedComponents/AddProductModal';

export interface CartState {
  isCartLoading: boolean;
  isCartApiLoading: boolean;
  cartData: Cart | null;
  promoCodes: string[] | null;
  ApplePay: {
    StoreTitle: string;
    VaultId: string;
    RouteId: string;
    IsApplePay: boolean;
  };
  GooglePay: {
    IsGooglePay: boolean;
    VaultId: string;
    StoreTitle: string;
    MerchantID: string;
    RouteID: string;
  };
  Paypal: {
    IsPaypalEnabled: boolean;
    VaultId: string;
    StoreTitle: string;
    MerchantID: string;
    RouteID: string;
  };
  funnelishProducts: IProductModalProps[];
}

const initialState: CartState = {
  isCartApiLoading: false,
  isCartLoading: false,
  cartData: null,
  promoCodes: null,
  ApplePay: {
    StoreTitle: '',
    RouteId: '',
    VaultId: '',
    IsApplePay: false,
  },
  GooglePay: {
    IsGooglePay: false,
    VaultId: '',
    StoreTitle: '',
    MerchantID: '',
    RouteID: '',
  },
  Paypal: {
    IsPaypalEnabled: false,
    VaultId: '',
    StoreTitle: '',
    MerchantID: '',
    RouteID: '',
  },
  funnelishProducts: [],
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setIsCartApiLoading(state, action) {
      state.isCartApiLoading = action.payload;
    },
    setIsCartLoading(state, action) {
      state.isCartLoading = action.payload;
    },
    setCartData(state, action: PayloadAction<Cart | null>) {
      state.cartData = action.payload;
    },
    setPromoCodes(state, action) {
      state.promoCodes = action.payload;
    },
    setApplePay: (state, action) => {
      state.ApplePay = action.payload;
    },
    setGooglePay: (state, action) => {
      state.GooglePay = action.payload;
    },
    setFunnelishProducts: (state, action) => {
      state.funnelishProducts = action.payload;
    },
    setSalesTax: (state, action) => {
      if (state.cartData) {
        state.cartData.SalesTaxAmount = action.payload.SalesTaxAmount;
        state.cartData.TotalAmount = action.payload.TotalAmount;
        if (action?.payload?.SalesTaxAmount)
          state.cartData.SalesTaxAmount = action.payload.SalesTaxAmount;
        if (action?.payload?.EstimatedTaxAmount)
          state.cartData.EstimatedTaxAmount = action.payload.EstimatedTaxAmount;
        if (action?.payload?.Fees) state.cartData.Fees = action.payload.Fees;
        if (action?.payload?.DiscountAmount)
          state.cartData.DiscountAmount = action.payload.DiscountAmount;
        if (action?.payload?.SubtotalAmount)
          state.cartData.SubtotalAmount = action.payload.SubtotalAmount;
        if (action?.payload && 'ShippingRequired' in action.payload)
          state.cartData.ShippingRequired = action.payload.ShippingRequired;
        if (action?.payload?.TicketEntries) {
          state.cartData.TicketEntries = action.payload.TicketEntries;
        }
      }
    },
  },
});

export const {
  setIsCartLoading,
  setCartData,
  setPromoCodes,
  setApplePay,
  setGooglePay,
  setSalesTax,
  setFunnelishProducts,
  setIsCartApiLoading,
} = cartSlice.actions;

export default cartSlice.reducer;
